import React from 'react';
import $ from 'jquery';
import printerService, { PRINTER_TRANSPORTS } from '../libs/printer/PrinterService';
import { getFriendlyPrinterError } from '../libs/printer/WebSerialPrinter';
import TicketTsplPreview from './TicketTsplPreview';
import { development } from '../libs/utils/Const';

class PrinterConfigurationModal extends React.Component {
    constructor(props) {
        super(props);
        const configuration = printerService.getConfiguration(props.user);
        this.state = {
            configuration,
            busy: false,
            showTicketPreview: false,
            status: this.configurationStatus(configuration)
        };
    }

    componentDidUpdate(previousProps) {
        if (previousProps.user !== this.props.user) {
            const configuration = printerService.getConfiguration(this.props.user);
            this.setState({ configuration, status: this.configurationStatus(configuration) });
        }
    }

    configurationStatus = (configuration) => {
        if (configuration.transport === PRINTER_TRANSPORTS.SYSTEM) {
            return 'Al imprimir podrá seleccionar cualquiera de las impresoras disponibles en el sistema.';
        }
        return printerService.isSupported(configuration)
            ? 'Selecciona y conecta la TSC para comenzar.'
            : 'Web Serial no esta disponible en este navegador.';
    };

    notify = (type, message) => {
        if (this.props.showAlert) this.props.showAlert({ type, message, timeOut: 8000 });
    };

    changePrinter = (value) => {
        const isSystemPrinter = value === PRINTER_TRANSPORTS.SYSTEM;
        this.setState(({ configuration }) => {
            const transport = isSystemPrinter ? PRINTER_TRANSPORTS.SYSTEM : PRINTER_TRANSPORTS.TSC;
            const nextConfiguration = {
                ...configuration,
                transport,
                model: isSystemPrinter ? 'Impresoras del sistema' : 'TSC Alpha-3R/3RB',
                printerName: null,
                portFingerprint: isSystemPrinter ? null : configuration.portFingerprint,
                paperWidthMm: 80,
                printableWidthDots: 576,
                baudRate: 9600
            };
            return { configuration: nextConfiguration, status: this.configurationStatus(nextConfiguration) };
        });
    };

    save = () => {
        const configuration = printerService.saveConfiguration(this.props.user, this.state.configuration);
        this.setState({ configuration, status: 'Configuracion guardada en este equipo.' });
        this.notify('success', 'Configuracion de impresora guardada.');
    };

    selectTsc = async () => {
        this.setState({ busy: true, status: 'Selecciona la TSC y espera mientras se establece la conexion...' });
        try {
            const configuration = await printerService.selectPrinter(this.props.user, this.state.configuration);
            this.setState({ configuration, busy: false, status: 'TSC conectada y lista para imprimir.' });
            this.notify('success', 'TSC Alpha-3R/3RB conectada correctamente.');
        } catch (error) {
            const message = getFriendlyPrinterError(error);
            this.setState({ busy: false, status: message });
            if (error.name !== 'NotFoundError') this.notify('error', message);
        }
    };

    testPrinter = async () => {
        this.setState({ busy: true, status: 'Preparando ticket de prueba...' });
        try {
            const configuration = await printerService.testPrinter(
                this.props.user,
                this.state.configuration,
                false,
                development
            );
            this.setState({
                configuration,
                busy: false,
                showTicketPreview: false,
                status: 'Ticket de prueba enviado a la impresora.'
            });
            this.notify('success', 'Ticket de prueba enviado.');
        } catch (error) {
            const message = getFriendlyPrinterError(error);
            this.setState({ busy: false, status: message });
            this.notify('error', message);
        }
    };

    close = () => {
        this.setState({ showTicketPreview: false });
        $('#printerConfigurationModal').modal('hide');
    };

    renderInstructions(isSystemPrinter) {
        if (isSystemPrinter) {
            return (
                <div className="alert alert-info">
                    <strong>Impresora predeterminada del sistema</strong>
                    <div className="mt-1">
                        El ticket se mandará a imprimir con la impresora del sistema. Se abrirá el diálogo de
                        impresión para que pueda seleccionar cualquiera de las impresoras que tenga disponibles.
                    </div>
                </div>
            );
        }
        return (
            <div className="border rounded bg-light p-3 mb-4">
                <div className="d-flex align-items-center mb-3">
                    <i className="fa fa-print text-primary mr-2" style={{ fontSize: 26 }} aria-hidden="true" />
                    <div>
                        <h6 className="font-weight-bold mb-0">Conecta tu impresora</h6>
                        <small className="text-muted">Sigue estos pasos solamente la primera vez.</small>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 mb-3 mb-md-0">
                        <div className="d-flex">
                            <span
                                className="badge badge-primary badge-pill mr-2"
                                style={{ minWidth: 24, height: 24, paddingTop: 6 }}
                            >
                                1
                            </span>
                            <div>
                                <strong className="d-block">Enciende la impresora</strong>
                                <small className="text-muted">
                                    Verifica que tenga batería, papel y que la luz esté encendida.
                                </small>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-3 mb-md-0">
                        <div className="d-flex">
                            <span
                                className="badge badge-primary badge-pill mr-2"
                                style={{ minWidth: 24, height: 24, paddingTop: 6 }}
                            >
                                2
                            </span>
                            <div>
                                <strong className="d-block">Conéctala a la computadora</strong>
                                <small className="text-muted">
                                    Usa Bluetooth de Windows.
                                </small>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="d-flex">
                            <span
                                className="badge badge-primary badge-pill mr-2"
                                style={{ minWidth: 24, height: 24, paddingTop: 6 }}
                            >
                                3
                            </span>
                            <div>
                                <strong className="d-block">Selecciónala aquí</strong>
                                <small className="text-muted">
                                    Pulsa “Seleccionar TSC” y elige la TSC en la ventana que aparecerá.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="alert alert-warning py-2 px-3 mt-3 mb-0">
                    <i className="fa fa-info-circle mr-2" aria-hidden="true" />
                    Usa Chrome o Edge. Si la impresora ya estaba conectada, comienza en el paso 3.
                </div>
            </div>
        );
    }

    render() {
        const {
            configuration, busy, status, showTicketPreview
        } = this.state;
        const isSystemPrinter = configuration.transport === PRINTER_TRANSPORTS.SYSTEM;
        const supported = printerService.isSupported(configuration);
        const fingerprint = configuration.portFingerprint || {};
        const fingerprintText = fingerprint.usbVendorId !== undefined
            ? `USB ${fingerprint.usbVendorId}:${fingerprint.usbProductId}`
            : fingerprint.bluetoothServiceClassId
                ? `Bluetooth ${fingerprint.bluetoothServiceClassId}`
                : 'Sin dispositivo seleccionado';
        const canTest = supported && (isSystemPrinter || Boolean(configuration.portFingerprint));
        const selectedValue = isSystemPrinter ? PRINTER_TRANSPORTS.SYSTEM : PRINTER_TRANSPORTS.TSC;

        return (
            <div className="modal" tabIndex="-1" role="dialog" id="printerConfigurationModal">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {showTicketPreview ? 'Vista previa del ticket de prueba' : 'Configurar impresora de tickets'}
                            </h5>
                            <button type="button" className="close" onClick={this.close} aria-label="Cerrar">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {development && showTicketPreview ? (
                                <>
                                    <div className="alert alert-info py-2">
                                        Esta vista reproduce el formato fijo de ticket de 80 mm.
                                    </div>
                                    <TicketTsplPreview configuration={configuration} />
                                </>
                            ) : (
                                <>
                                    {this.renderInstructions(isSystemPrinter)}
                                    <div className="form-row">
                                        <div className="form-group col-md-8">
                                            <label htmlFor="printerType">Impresora</label>
                                            <select
                                                id="printerType"
                                                className="form-control"
                                                value={selectedValue}
                                                disabled={busy}
                                                onChange={(event) => this.changePrinter(event.target.value)}
                                            >
                                                <option value={PRINTER_TRANSPORTS.TSC}>
                                                    TSC Alpha-3R/3RB (conexion directa)
                                                </option>
                                                <option value={PRINTER_TRANSPORTS.SYSTEM}>
                                                    Impresora predeterminada del sistema
                                                </option>
                                            </select>
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label>Conexion</label>
                                            <input
                                                className="form-control"
                                                value={isSystemPrinter ? 'Impresora predeterminada' : 'Web Serial (Bluetooth)'}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="border rounded bg-light p-3 mb-3">
                                        <div className="row">
                                            <div className="col-md-6"><strong>Modelo:</strong> {configuration.model}</div>
                                            <div className="col-md-3"><strong>Papel:</strong> 80 mm</div>
                                            <div className="col-md-3"><strong>Formato:</strong> Fijo</div>
                                        </div>
                                        <small className="text-muted">
                                            Los parametros del ticket no pueden ser modificados por el usuario.
                                        </small>
                                    </div>
                                    <p className="mb-1">
                                        <strong>Dispositivo:</strong>{' '}
                                        {isSystemPrinter ? 'Predeterminada de Windows' : fingerprintText}
                                    </p>
                                    <p className="text-muted mb-0">{status}</p>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            {development && showTicketPreview ? (
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        disabled={busy}
                                        onClick={() => this.setState({ showTicketPreview: false })}
                                    >
                                        Volver
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        disabled={busy || !canTest}
                                        onClick={this.testPrinter}
                                    >
                                        Confirmar e imprimir
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button type="button" className="btn btn-secondary" onClick={this.close}>Cerrar</button>
                                    <button type="button" className="btn btn-outline-primary" disabled={busy} onClick={this.save}>
                                        Guardar
                                    </button>
                                    {!isSystemPrinter && (
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={busy || !supported}
                                            onClick={this.selectTsc}
                                        >
                                            Seleccionar TSC
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        disabled={busy || (!development && !canTest)}
                                        onClick={development
                                            ? () => this.setState({ showTicketPreview: true })
                                            : this.testPrinter}
                                    >
                                        <i className={`fa ${development ? 'fa-eye' : 'fa-print'} mr-1`} />
                                        {development ? 'Vista previa del ticket' : 'Imprimir prueba'}
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PrinterConfigurationModal;
